module.exports = __webpack_public_path__ + "static/media/success.27205b0b.png";